

<div class="contents">
  <div class="asset_in_dispute">
  <div class="top">
    <h2 class="title">Assets in Dispute</h2>
    <!-- <button class="default_secondary-btn">Add Asset</button> -->
  </div>
  <div class="toggle_view">
    <mat-button-toggle-group
  name="fontStyle"
  aria-label="Font Style"
  color="accent"
  class="m-3"
  
  >
  <mat-button-toggle value="list" color="accent" (click)="onList()"
    ><mat-icon class="example-tab-icon"
      >list</mat-icon
    ></mat-button-toggle
  >
  <mat-button-toggle value="grid" (click)="onGrid()"
    ><mat-icon class="example-tab-icon"
      >view_module</mat-icon
    ></mat-button-toggle
  >
  </mat-button-toggle-group>
  </div>
  <form  [formGroup]="adrassetForm">
    <div class="entry_values"  *ngIf="gridView">
      <div class="entry" *ngFor="
      let asset of selectedSuitProgresss.adrAssets;
      index as i
    ">
        <h1 class="section_name">{{asset.LandName}}</h1>

        <div class="other_info">
          <p class="label">State: <span class="item">{{asset.StateName}}</span></p>
          <p class="label">Lga: <span class="item">{{asset.LgaName}}</span></p>
          <p class="label">Community: <span class="item">{{asset.CommunityName}}</span></p>
        </div>

        <div class="input_value">
          <span class="label">Remark</span>
          <p class="item">{{asset.Remarks}}</p>
        </div>
      </div>

    </div>
  </form>
  </div>
</div>

<div class="card" *ngIf="listView">
  <div class="asset_in_dispute tab_content">
  <form  [formGroup]="adrassetForm">
  <table class="table table-hover" >
    <thead>
      <tr>
        <th scope="col">S/N</th>
        <th scope="col">Asset Name</th>
        <th scope="col">State</th>
        <th scope="col">Lga</th>
        <th scope="col">Community</th>
        <th scope="col">Remarks</th>
      </tr>
    </thead>
    <tbody >
      <tr *ngFor="
      let asset of selectedSuitProgresss.adrAssets;
      index as i
    ">
        <th scope="row">{{i + 1}}</th>
        <td>{{asset.LandName}}</td>
        <td>{{asset.StateName}}</td>
        <td>{{asset.LgaName}}</td>
        <td>{{asset.CommunityName}}</td>
        <td>{{asset.Remarks}}</td>
      </tr>

    </tbody>
  </table>
</form>
</div>
</div>